// extracted by mini-css-extract-plugin
export default {"swiper":"PerformanceSlider_swiper__GU+Mc","swiper-slide":"PerformanceSlider_swiper-slide__wKZtc","swiper-wrapper":"PerformanceSlider_swiper-wrapper__ogE-U"};